import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import QuotaNotice from "./QuotaNotice";
import UserMenu from "./UserMenu";

// `extra` permanece disponível para conteúdo adicional entre a marca e o
// indicador de cota, mas nenhum uso atual passa esse prop.
interface Props {
  extra?: ReactNode;
}

export default function Header({ extra }: Props) {
  return (
    <header className="flex items-center justify-between gap-4 py-2">
      <div className="flex items-center gap-5">
        <Link
          to="/"
          className="text-lg font-semibold text-ink-100 font-display tracking-[-0.3px] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400/50 rounded"
        >
          Pesquisa de Seguros
        </Link>
        <Link
          to="/history"
          className="text-sm font-medium text-ink-400 hover:text-ink-100 font-body transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400/50 rounded"
        >
          Histórico
        </Link>
      </div>

      <div className="flex items-center gap-4">
        {extra}
        <QuotaNotice variant="badge" />
        <UserMenu />
      </div>
    </header>
  );
}
